<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h1>Copyright</h1>
</div>
</div>
<p class="double" style="text-align: center;">Diversion Books<br/>
    A Division of Diversion Publishing Corp.<br/>
    443 Park Avenue South, Suite 1004<br/>
    New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="double" style="text-align: center;">Copyright © 1991 by Jane Bonander<br/>
    All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="double" style="text-align: center;">This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="double" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p style="text-align: center;">First Diversion Books edition December 2013<br/>
    ISBN: <span style="font-family: 'Liberation Serif', serif; font-size: 1em; line-height: 1.375; text-align: justify;">978-1-62681-186-7</span></p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<h1>More from Jane Bonander</h1>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/chap212681" title="Link target outside of Sample">Heat of a Savage Moon</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/chap212681" title="Link target outside of Sample">Forbidden Moon</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/chap212681" title="Link target outside of Sample">Fires of Innocence</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/chap212681" title="Link target outside of Sample">Dancing on Snowflakes</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/chap212681" title="Link target outside of Sample">Wild Heart</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/chap212681" title="Link target outside of Sample">Warrior Heart</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/chap212681" title="Link target outside of Sample">Winter Heart</span></p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<p class="sectiontop" style="text-align: center;"><em>For my parents, Floyd and Mabel Olson, with love and thanks.</em></p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<p class="sectiontop" style="text-align: center;">Before you go over the snow-mountain to the north,</p>
<p class="first" style="text-align: center;">Downhill toward the north,</p>
<p class="first" style="text-align: center;">Oh me, do look back to me.</p>
<p class="first" style="text-align: center;"><br/>
    You who dwell below the snow-mountain,</p>
<p class="first" style="text-align: center;">Do look back to me.</p>
<p class="first" style="text-align: right;"><br/>
    Wintu Love Song</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_0000312926227_copy.vue?4e465dd8